module.exports = __webpack_public_path__ + "static/media/home_header.db952935.jpg";